import React from 'react'
import SingleCollectionDetailComp from '../../components/explore/singleCollectionDetails/SingleCollectionDetailComp'

const SingleCollectionDetail = () => {
  return (
   <SingleCollectionDetailComp/>
  )
}

export default SingleCollectionDetail